//Highlight.ts ==============================================================
import "../Util/Prototypes";

import * as DrawerMenu from "../Menus/DrawerMenu";
import * as ElevationProfile from "../Widgets/ElevationProfile";
import * as GetSearchResults from "../Search/GetSearchResults";
import * as GraLay from "../Util/GraLay";
import * as Highlight from "../Util/Highlight";
import * as HighlightGraphics from "../Util/HighlightGraphics";
import * as Identify from "../Widgets/Identify";
import * as MainMap from "../MainMap";
import * as Search from "../Search/Search";
import * as SelectionMode from "../Search/SelectionMode";
import * as SelectOnMap from "../Search/SelectOnMap";
import * as Settings from "../Settings";
import * as Util_App from "../Util/Util_App";

//ESRI javascript API.
import Point from "@arcgis/core/geometry/Point";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";

export let stationary: boolean = true;
//const identifyEnabledTools: string[] = ["", "Advanced Search", "Basemap Gallery", "Bookmarks", "Compare Maps", "Export Map", "Legend", "Map Layers", "Map Themes", "Print", "Quick Search", "Search Results"];
const identifyEnabledTools: string[] = ["", "Basemap Gallery", "Bookmarks", "Compare Maps", "Export Map", "Legend", "Map Layers", "Map Themes", "Print", "Sales Results", "Search Results"];

const hoverGraphicEnabledTools: string[] = identifyEnabledTools.slice(0);  //Clone array.;
hoverGraphicEnabledTools.push("Select on Map");

//interface iIdentify {
//   url: string; //Url of map service layer
//   params: __esri.IdentifyParameters; //One parameters for each map service.
//   layerVisible: boolean; //Array of is the map service visible.
//}

//let identifies: iIdentify[];
//let ii: number; //Index into the above array.
//let identifyResults: any;

//let dist: number = 999;
//let prevScreenPnt: __esri.Point;
//let screenPnt: __esri.Point;
//let oneMoreTime: boolean = false;
//let busy: boolean = false;

//Initialize identify tasks and parameters for map image layers.
export function createIdentifyTasks() {
   //identifies = [];

   //Process all identify settings for map image layers.
   //for (const idSpec of Settings.identifyLayersMI) {

   //   //Initialize parameters.
   //   const params = new __esri.IdentifyParameters();
   //   params.maxAllowableOffset = Util_App.feetToMeters(Settings.maxAllowableOffset);

   //   if (!MainMap.activeView.spatialReference.isWebMercator) {
   //      params.geometryPrecision = 0;
   //   }

   //   params.returnFieldName = true;
   //   params.returnGeometry = true;

   //   identifies.Add({ url: idSpec.mapServiceURL, params: params, layerVisible: false });
   //}
   //updateParameters();

   //Mouse move event to highlight map image sublayers and feature layers.
   MainMap.activeView.on("pointer-move", function (event: __esri.ViewPointerMoveEvent) {
      const buttons = event.native.buttons as number;
      const shiftKey = event.native.shiftKey as boolean;

      if (!shiftKey && buttons === 0 && Highlight.stationary) { //Skip pan and zoom operations.
         if (ElevationProfile?.elevationProfileWidget?.visible) {
            return; //Don't highlight if using elevation profile tool.
         }
         if ((SelectOnMap.active && SelectOnMap.createTool === "point") ||
            (Settings.selectOnMapAlwaysActive && hoverGraphicEnabledTools.Contains(DrawerMenu.curToolName)) ||
            (!SelectOnMap.active && Settings.identifyEnabled && hoverGraphicEnabledTools.Contains(DrawerMenu.curToolName))) {
            HighlightGraphics.mapMouseMove(event); //Highlight selected graphics and feature layers.
         }

         //if ((SelectOnMap.active && SelectOnMap.mode === "point") ||
         //   (!SelectOnMap.active && identifyEnabledTools.Contains(DrawerMenu.curToolName))) {
         //   mapMouseMove(event); //Highlight map image sublayer features.
         //}
      }
   });

   //Process mouse out event.
   MainMap.activeView.on("pointer-leave", function () {
      setTimeout(function () { GraLay.clearHoverGraphics(); }, 300);
      setTimeout(function () { GraLay.clearSelectHoverGraphics(); }, 300);
   });

   //Interacting with map view.
   reactiveUtils.when(() => MainMap.activeView?.interacting === true, function () {
      stationary = false;
   });

   //Map view is stationary.
   reactiveUtils.when(() => MainMap.activeView?.stationary === true, function () {
      stationary = true;
      //   if (identifies.length > 0) {
      //      updateParameters(); //Update parameters after map scale changes, etc.
      //   }
   });

   //Select on Map and Identify click event.  Note - ESRI disables this event when select on map tool is active.
   MainMap.activeView.on("click", function (event: __esri.ViewClickEvent) {
      if (MainMap.activeView.ready) {
         if (!SelectOnMap.active && !ElevationProfile?.elevationProfileWidget?.visible &&
            identifyEnabledTools.Contains(DrawerMenu.curToolName)) {
            const pnt = new Point({ x: event.x, y: event.y, spatialReference: MainMap.activeView.spatialReference });
            const geom = MainMap.activeView.toMap({ x: pnt.x, y: pnt.y });

            if (Settings.selectOnMapAlwaysActive) {
               Search.setActiveSearchTool("");
               SelectOnMap.setGeom(geom);
               GetSearchResults.init();

               //} else {
               //   Identify.init(geom);
            }
         }
      }
   });
}

//Update identify parameters after map scale change or layers on/off changes.
//export function updateParameters() {

//   //Process all identify settings for map image layers.
//   for (let i = 0; i < Settings.identifyLayersMI.length; i++) {
//      const idSpec: Settings.iIdentifyLayerMI = Settings.identifyLayersMI[i];

//      //Map service visiblity.
//      const layer = Util_App.getOperationalLayerById(idSpec.mapServiceID) as __esri.MapImageLayer;
//      identifies[i].layerVisible = false;

//      if (layer && layer.visible) {
//         //Parameters.
//         const params = identifies[i].params;

//         if (SelectOnMap.active && SelectOnMap.selectableLayer !== "All Visible Layers") {
//            params.layerOption = "all";
//         } else {
//            params.layerOption = "visible";  //Means map service is visible and within scale.  Sub-layer visibility not recognized.
//         }

//         params.height = MainMap.activeView.height;
//         params.mapExtent = MainMap.activeView.extent;
//         params.tolerance = Util_App.getSelectByPointTolerance();
//         params.width = MainMap.activeView.width;

//         //Get visible sublayer id's for identify and visible/hidden id's for select on map for single sublayer option.
//         params.layerIds = null;
//         const subLayerIds = Util_App.getHoverSubLayerIndexes(layer);

//         if (subLayerIds.length > 0) {
//            if (Util_App.areSublayersAllPolygon(layer, subLayerIds)) {
//               params.tolerance = 1;
//            }

//            identifies[i].layerVisible = true;
//            params.layerIds = subLayerIds;
//         }
//      }
//   } //End for all identify layer settings.
//}

//Not used - was for map image service highlighting. Highlight identifiable features when hovering over map.
//function mapMouseMove(event: __esri.ViewPointerMoveEvent) {
//   if (!Spinner.busy) {
//      screenPnt = new Point({ x: event.x, y: event.y, spatialReference: MainMap.activeView.spatialReference });

//      oneMoreTime = true;
//      setTimeout(function () { doItOneMoreTime(); }, 200);

//      if (busy) {
//         //Util.errMsg("It's busy baby");
//         return;
//      }

//      if (prevScreenPnt) {
//         dist = screenPnt.distance(prevScreenPnt);
//      }

//      //Util.logMsg("Distance: " + dist);
//      prevScreenPnt = screenPnt;

//      if (dist < 2) {
//         oneMoreTime = false;
//         processMouseMove();
//      }
//   }
//}

//Process mouse move..
//function doItOneMoreTime() {
//   if (!busy && oneMoreTime && !Spinner.busy) {
//      processMouseMove();
//   }
//}

//Process mouse move..
//function processMouseMove() {
//   //Util.errMsg("processMouseMove top returnFieldName: " + identifies[0].params.returnFieldName);

//   busy = true;
//   identifyResults = [];
//   ii = -1;
//   const pnt = MainMap.mapView.toMap({ x: screenPnt.x, y: screenPnt.y });
//   executeIdentifyTask(pnt);
//}

//Get identify results for map image layers.
//function executeIdentifyTask(pnt: any) {
//   ii++; //Process next identify setting.
//   //Util.errMsg("After ii++: " + ii);

//   if (ii < Settings.identifyLayersMI.length) {
//      if (identifies[ii].layerVisible) {
//         //Set the parameters for the identify.
//         const params: any = identifies[ii].params;
//         params.geometry = pnt;

//         //Create identify task for the specified map service
//         IdentifyTask.identify(identifies[ii].url, params).then(function (response) {
//            const results = response.results;

//            if (results.length > 0) {
//               identifyResults = identifyResults.concat(results);

//               //Util.errMsg('Layer: ' + results[0].layerName, results);
//            } else {
//               //Util.logMsg("No records found");
//            }

//            //Returns: displayFieldName, feature, layerName
//            executeIdentifyTask(pnt); //Process next identify layer setting.

//         }, function (error: Error) {
//            Util.errMsg('Identify Task Failed', error);
//            Util.errMsg('Identify Parameters', params);
//            executeIdentifyTask(pnt); //Process next identify layer setting.
//         });

//      } else { //Skip layer if not visible.
//         executeIdentifyTask(pnt);
//      }

//   } else { //All map services have been processed.
//      highlightResults();
//   }
//}

//See if feature should be highlighted.
export function shouldBeHighlighted(gra: __esri.Graphic, layName: string): boolean {
   const layerName = layName.replace(" Highlight", "");
   const oid: number = Util_App.getObjectId(gra);

   //Make sure layer name is in the list to be searched or identified.
   if (!(Settings.selectableLayers.Contains(layerName) || Settings.identifyLayers.Contains(layerName))) {
      return false;
   }

   //Determine if feature is already selected.
   let selected: boolean = false;

   for (const lay of Search.layers) {
      if (lay.spec.layerName === layerName) {
         for (let i = lay.begRec; i <= lay.endRec; i++) {
            const feature = lay.fs.features[i];
            const oidSelect: number = Util_App.getObjectId(feature);
            if (oidSelect === oid) {
               selected = true;
               break;
            }
         }
      }
   }

   //Determine if feature needs highlighting.
   let doIt: boolean = false;

   if (SelectOnMap.active) { //Select on map mode.
      if (Settings.selectableLayers.Contains(layerName)) {
         if (SelectionMode.value === "New") {
            doIt = true;

         } else if (SelectionMode.value === "Add" && !selected) {
            doIt = true;

         } else if (SelectionMode.value === "Remove" && selected) {
            doIt = true;
         }
      }

   } else { // Identify mode and hover over feature layer mode.
      if (Settings.identifyLayers.Contains(layerName)) {
         if (!selected) {
            if (identifyEnabledTools.Contains(DrawerMenu.curToolName)) {
               doIt = true;
            }
         }
      }
   }

   return doIt;
}

//Highlight identify results on mouse hover.
//function highlightResults() {
//   GraLay.clearHoverGraphics();

//   for (const result of identifyResults) {
//      const gra = result.feature;

//      if (shouldBeHighlighted(gra, result.layerName)) {
//         Util_App.highlightGraphic(gra, true);
//         MainMap.activeViewDiv.style.cursor = "pointer";

//      } else {
//         //MainMap.activeViewDiv.style.cursor = "default";
//      }
//   }
//   busy = false; //All done.
//}
